import Vue from 'vue';
import swal from 'sweetalert2';
import {addGroup} from '../utility/api/group/addGroup';

Vue.component('add-group', {
  data() {
    return {
      name: 'New Group',
      processing: false,
      error: null,
    };
  },
  methods: {
    createGroup() {
      this.processing = true;

      addGroup({name: this.name})
        .then(({id: groupId}) => {
          $.notify('Saved!', 'success');
          let token = btoa('group_id=' + groupId);

          setTimeout(() => {
            window.location.href = '/inventory/contacts/groups/edit/?sk_token=' + token;
          }, 2000);
        })
        .catch(error => {
          const {data} = error.response || {};
          if (data && data.errors && data.errors.name) {
            this.error = data.errors.name[0];
          }

          this.processing = false;
          swal.fire({
            title: 'UhOh!',
            text: this.error || 'There was a problem processing your request. Please try again later.',
            type: 'error',
            confirmButtonText: 'Ok',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-lg btn-primary',
          });
        });
    },
  },
  mounted() {
    document.getElementById('group-name-input').value = '';
  },
});
